const customMediaQuery = (maxWidth: number) =>
  `@media (max-width: ${maxWidth}px)`;
export const media = {
  custom: customMediaQuery,
  desktop: customMediaQuery(1490),
  tablet: customMediaQuery(1024),
  phone: customMediaQuery(576),
};
